<div class="fullscreen-container row" [ngSwitch]="etat">
  <div class="col-sm-12" *ngSwitchCase="'loaded'">
    <a routerLink="/motifsdecontact" class="bleu-caf ">
      <div class="d-block d-sm-block d-md-none bouton-retour cnaf-background1 cnaf-margin-mobile">
        <img alt="" src="/icfstatiquesangularappli/dist/images/burger_chevron_gauche_gris.png" />
        Retour
      </div>
    </a>
    <h2>
      Vous changez de situation familiale ou professionnelle
    </h2>
    <div role="group" aria-labelledby="modifier-profil">
      <p id="modifier-profil">
        Vous pouvez modifier immédiatement votre
        situation en ligne depuis votre Profil </p>
      <button (click)="onModifierProfilEnLigne()" class="btn btn-secondary-cnaf btn-block btn-motifcontact margin">
        Modifier mon profil en ligne
      </button>
    </div>

    <div role="group" aria-labelledby="modifier-moment-vie">
      <p id="modifier-moment-vie">
        Vous souhaitez être guidé via les parcours
        en ligne dédiés aux moments de vie
        suivants :
      </p>
      <button (click)="onArriverEnfant()" class="btn btn-secondary-cnaf btn-block btn-motifcontact margin">
        Arrivée de l’enfant
      </button>
      <button (click)="onSeparation()" class="btn btn-secondary-cnaf btn-block btn-motifcontact margin">
        Séparation
      </button>
    </div>
    <div class="haut"></div>
    <p>Ou</p>
    <div class="bas"></div>
    <button type="button" #appelCaf class="btn btn-secondary-cnaf btn-block btn-motifcontact margin"
      (click)="appelerMaCaf()">
      Appeler
    </button>
  </div>
  <div class="col-sm-12 espacement" *ngSwitchCase="'loading'">
    <div class="progress">
      <div class="progress-bar progress-bar-info progress-bar-striped active" role="progressbar" aria-valuenow="40"
        aria-valuemin="0" aria-valuemax="100">
        Chargement en cours...
      </div>
    </div>
  </div>
</div>